<template>
  <div class="wrapper">
    <loading :height="25" color="#1ba5a4" :opacity="1" :width="25" :active.sync="is_loading" :is-full-page="false"
      :can-cancel="false" background-color="#ffffff" class="loader"></loading>
  </div>
</template>
<script>
export default {
  name: "loader",
  components: {},
  data() {
    return {
      is_loading: true,
    };
  },
  watch: {},
  mounted() {
    let vm = this;
    vm.validateToken();
  },
  methods: {
    validateToken() {
      let vm = this;
      vm.$store
        .dispatch("VALIDATE_TOKEN", {
          crm_token: vm.$route.params.crm_token,
          site_token: vm.$route.params.site_token,
        })
        .then((response) => {
          sessionStorage.authToken = vm.$route.params.crm_token;
          sessionStorage.siteAuthToken = vm.$route.params.site_token;
          sessionStorage.setItem("isLogedIn", true);
          sessionStorage.setItem("account_type", response.data.account_type);
          vm.$store.commit("AUTH_REQUEST", response.data);
          vm.$store.commit("INITIALIZE_APP_DATA", {
            token: vm.$route.params.site_token,
            id: response.data.id,
          });
          vm.$localStorage.set(
            "logged_user_data",
            JSON.stringify(response.data)
          );
          let roles = response.data.roles;
          // Setting main role
          let main_role = null;
          roles.forEach((i) => {
            if (!main_role) {
              roles.forEach((item) => {
                if (item == "super-manager") {
                  main_role = "super-manager";
                } else if (item == "department-manager") {
                  main_role = "department-manager";
                } else if (item == "team-manager") {
                  main_role = "team-manager";
                }
              });
            }
          });
          vm.$localStorage.set("main_role", main_role);

          // Setting prefix
          let role_url = "";
          if (roles.length > 0) {
            vm.$localStorage.set("role", main_role);
            role_url = "/" + main_role;
            vm.$store.commit("SET_CRM_PREFIX", { prefix: role_url });
            if (vm.$route.query.path) {
              vm.$router.push({ path: vm.$route.query.path, query: vm.$route.query });
            } else {
              vm.$router.push({ path: "/school" });
            }
          } else {
            vm.$notify({
              group: "status",
              title: "Warning",
              text: "Something wrong with permission",
              type: "warn",
              duration: 3000,
            });
          }
        })
        .catch((error) => {
          window.parent.postMessage({ message: "logoutUser", value: "" }, "*");
          console.error({ error });
        });
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
